import palette from '../palette';

const MuiToggleButtonGroup = {
  styleOverrides: {
    root: {
      '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
        borderLeft: `1px solid ${palette.secondary.main}`,
      },
      borderRadius: '4px',
      height: 32,
    },
  },
  variants: [
    {
      props: { fullWidth: true },
      style: {
        width: '100%',
      },
    },
    {
      props: { variant: 'navigation' },
      style: {
        '@media min-width(900px)': {
          height: 48,
        },
        height: 56,
      },
    },
  ],
};

export default MuiToggleButtonGroup;
